export default "__VITE_ASSET__Cm5b5qXa__"